<template>
  <div style="background: #fff;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Order History</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="font-size:24px;font-weight:bold;color:#000;margin:35px 0 0 132px;">Filling out after-sales information</div>
    <div style="font-size:16px;color:#8d8d8d;margin:22px 0 35px 132px;">*Required Fields</div>
    <div class="box">
      <el-form autoComplete="on"
               :model="salesForm"
               :rules="salesRules"
               ref="salesForm"
               class="box-content">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="customOrderNumber" label="Thorlabs Order Number">
              <el-input name="customOrderNumber" class="ipt"
                        type="text"
                        v-model="salesForm.customOrderNumber"
                        autoComplete="off"
                        placeholder="Enter Order Number">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="customPoNumber" label="Your PO Number">
              <el-input name="customPoNumber" class="ipt"
                        type="text"
                        v-model="salesForm.customPoNumber"
                        autoComplete="off"
                        placeholder="Enter PO Number">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="firstName" label="Contact First Name">
              <el-input name="firstName" class="ipt"
                        type="text"
                        v-model="salesForm.firstName"
                        autoComplete="off"
                        placeholder="Enter First Name">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="lastName" label="Contact Last Name">
              <el-input name="lastName" class="ipt"
                        type="text"
                        v-model="salesForm.lastName"
                        autoComplete="off"
                        placeholder="Enter Last Name">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item prop="emailAddress" label="Email">
              <el-input name="emailAddress" class="ipt2"
                        type="text"
                        v-model="salesForm.emailAddress"
                        autoComplete="off"
                        placeholder="Enter Contact Email">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="phone" label="Phone">
              <el-input name="phone" class="ipt2"
                        type="text"
                        v-model="salesForm.phone"
                        autoComplete="off"
                        placeholder="Enter Phone">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="company" label="Company">
              <el-input name="company" class="ipt2"
                        type="text"
                        v-model="salesForm.company"
                        autoComplete="off"
                        placeholder="Enter Company">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-row>
            <el-col :span="24" style="display: flex;">
              <el-checkbox v-model="checked" :disabled="checked2" style=""></el-checkbox>
              <el-row style="flex: 1;">
                <el-col :span="6">
                  <div>Return Entire</div>
                </el-col>
                <el-col :span="16">
                  <div style="border:1px solid #e1e1e1;padding:10px;">
                    <div style="display: flex;">
                      <div style="width:30%">*Returning Part No.</div>
                      <div style="width:30%">*Return Oty</div>
                      <div style="width:30%">*Serial Number/Lot ID(if available)</div>
                    </div>
                    <div v-for="(v,index) of items" :key="index">
                      <el-input name="partNo" class="ipt2"
                        type="text"
                        style="width:29%;margin-right:1%;margin-bottom:12px"
                        v-model="v.partNo"
                        autoComplete="off"
                        :disabled="checked2"
                        placeholder="">
                      </el-input>
                      <el-input name="oty" class="ipt2"
                        type="text"
                        style="width:29%;margin-right:1%;margin-bottom:12px"
                        v-model="v.oty"
                        autoComplete="off"
                        :disabled="checked2"
                        placeholder="">
                      </el-input>
                      <el-input name="serialNumber" class="ipt2"
                        type="text"
                        style="width:29%;"
                        v-model="v.serialNumber"
                        autoComplete="off"
                        :disabled="checked2"
                        placeholder="">
                      </el-input>
                    </div>
                    <div style="background:#f5f5f5;height:50px;line-height:50px;text-align:right;padding-right:20px;"><el-button type="text" @click="addList" :disabled="checked2">Add Another Part</el-button></div>
                  </div>
                </el-col>
              </el-row>
              </el-col>
            </el-row>
          <el-row>
            <el-col :span="24" style="display: flex;">
              <el-checkbox v-model="checked2" :disabled="checked" style=""></el-checkbox>
              <el-row style="flex: 1;">
                <el-col :span="6">
                  <div>Replacement Required?</div>
                </el-col>
                <el-col :span="16">
                  <div style="border:1px solid #e1e1e1;padding:10px;">
                    <div style="display: flex;">
                      <div style="width:30%">Replacement Part No.(if Different)</div>
                      <div style="width:30%">*Replacement Qty(if Different)</div>
                    </div>
                    <div v-for="(v,index) of items2" :key="index">
                      <el-input name="partNo" class="ipt2"
                        type="text"
                        style="width:29%;margin-right:1%;margin-bottom:12px"
                        v-model="v.partNo"
                        autoComplete="off"
                        :disabled="checked"
                        placeholder="">
                      </el-input>
                      <el-input name="oty" class="ipt2"
                        type="text"
                        style="width:29%;margin-right:1%;margin-bottom:12px"
                        v-model="v.oty"
                        autoComplete="off"
                        :disabled="checked"
                        placeholder="">
                      </el-input>
                    </div>
                    <div style="background:#f5f5f5;height:50px;line-height:50px;text-align:right;padding-right:20px;"><el-button type="text" @click="addList2" :disabled="checked">Add Another Part</el-button></div>
                  </div>
                </el-col>
              </el-row>
              </el-col>
            </el-row>
        </el-form-item>
        <el-form-item style="margin-bottom: 49px">
          <a class="loginBtn a1" :loading="loading" @click="handleSumit">
            OK
          </a>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
    import { salesOrderSave } from '@/api/Persona/index' ;
    const defaultSales = {
      customOrderNumber: '',
      customPoNumber: '',
      firstName: '',
      lastName: '',
      emailAddress: '',
      phone: '',
      company: '',
      type: 0,
  };
    export default {
        name: 'Aftersales',
        data () {
            return {
              salesForm: Object.assign({}, defaultSales),
              salesRules: {
                firstName: [{required: true, trigger: 'blur', message: 'enter' }],
                lastName: [{required: true, trigger: 'blur', message: 'enter'}],
                emailAddress: [{required: true, trigger: 'blur', message: 'enter' }],
                phone: [{required: true, trigger: 'blur', message: 'enter'}],
                company: [{required: true, trigger: 'blur', message: 'enter' }],
              },
              loading: false,
              checked: false,
              checked2:false,
              items:[{oty:'', partNo:'', serialNumber:''}],
              items2:[{oty:'', partNo:'', serialNumber:''}],
              orderId: '',
            }
        },
        created() {
          console.log(this.$route, 'this.$route');
          console.log(this.$route.query, 'this.$route.query');
          this.orderId = this.$route.query.id
        },
        mounted() {
        },
        methods: {
          handleSumit() {
            this.$refs.salesForm.validate(valid => {
              if (valid) {
                this.loading = true;
                console.log(this.checked, 'this.checked');
                console.log(this.checked2, 'this.checked2');
                if (this.checked == true && this.checked2 == false) {
                  this.salesForm.type = 1;
                  this.salesForm.items = this.items;
                } else {
                  this.salesForm.type = 0;
                  this.salesForm.items = this.items2;
                }
                this.salesForm.orderId = this.orderId;
                console.log(this.items, 'items1');
                salesOrderSave(this.salesForm).then((res) => {
                    console.log(res, 'salesOrderSave');
                    this.loading = false
                    this.$router.push({name: "PersonalInformation",query:{tab:'Order History'}});
                  }).catch(() => {
                    this.loading = false
                  });
              } else {
                return false
              }
            })
          },
          addList(){
            this.items.push({oty:'', partNo:'', serialNumber:''})
          },
          addList2() {
            this.items2.push({oty:'', partNo:'', serialNumber:''})
          }
        },
    }
</script>

<style scoped>
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
.box{
    height:100%;
    width:100%;
    overflow: auto;
    min-height: 100vh;
  }
  .box-content {
    padding:0 140px;
    text-align:left;
  }
  .ipt {
    width:515px;
  }
  .ipt2 {
    width: 330px;
  }
  ::v-deep .el-form-item__label {
    font-size:16px;
    font-weight:bold;
    color:#343434;
  }
  .loginBtn{
    padding:15px 24px;
    background: #00718c;
    border-radius:6px;
    color: #ffffff;
    font-size:20px;
    font-weight:bold;
  }
</style>